import { render, staticRenderFns } from "./ListInvestors.vue?vue&type=template&id=5c537c37&"
import script from "./ListInvestors.vue?vue&type=script&lang=js&"
export * from "./ListInvestors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports